var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import OriginalDialog from '../atoms/Dialog';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import jaNewRoasterCampaignImg from '../../images/new-roaster-campaign-ja.jpg';
import deNewRoasterCampaignImg from '../../images/new-roaster-campaign-de.jpg';
import enNewRoasterCampaignImg from '../../images/new-roaster-campaign-en.jpg';
import frNewRoasterCampaignImg from '../../images/new-roaster-campaign-fr.jpg';
import itNewRoasterCampaignImg from '../../images/new-roaster-campaign-it.jpg';
import koNewRoasterCampaignImg from '../../images/new-roaster-campaign-ko.jpg';
import zhTwNewRoasterCampaignImg from '../../images/new-roaster-campaign-zh-Tw.jpg';
import { campaignCheckedState } from '../../recoil/campaignCheckedState';
import { IconButton } from '@mui/material';
import { CloseDialogIcon } from '../atoms/Icons';
import { setCampaignDialogChecked } from '../../localStorage';
import { useLocation } from 'react-router-dom';
var Dialog = styled(OriginalDialog)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    .MuiPaper-root {\n      background-color: transparent;\n      border-radius: unset;\n      box-shadow: none;\n    }\n\n    .MuiDialogContent-root {\n      padding: 0;\n      margin: 0;\n      min-height: 50px;\n    }\n  }\n"], ["\n  && {\n    .MuiPaper-root {\n      background-color: transparent;\n      border-radius: unset;\n      box-shadow: none;\n    }\n\n    .MuiDialogContent-root {\n      padding: 0;\n      margin: 0;\n      min-height: 50px;\n    }\n  }\n"])));
var CampaignCheckDialog = function () {
    var i18n = useTranslation().i18n;
    var _a = React.useState(false), open = _a[0], setOpen = _a[1];
    var setCampaignChecked = useSetRecoilState(campaignCheckedState);
    var campaignChecked = useRecoilValue(campaignCheckedState);
    var location = useLocation();
    React.useEffect(function () {
        setOpen(Boolean(campaignChecked));
    }, [campaignChecked]);
    var onClose = React.useCallback(function () {
        setOpen(false);
        setCampaignDialogChecked({ checked: 1 });
        setCampaignChecked(function () { return false; });
    }, [setCampaignChecked]);
    var campaignLocaleImage = React.useMemo(function () {
        return {
            ja: jaNewRoasterCampaignImg,
            en: enNewRoasterCampaignImg,
            ko: koNewRoasterCampaignImg,
            'zh-TW': zhTwNewRoasterCampaignImg,
            it: itNewRoasterCampaignImg,
            es: enNewRoasterCampaignImg,
            de: deNewRoasterCampaignImg,
            fr: frNewRoasterCampaignImg,
        };
    }, []);
    var isPassedCampaignPeriod = React.useMemo(function () {
        var endDateTime = new Date('2022-12-31T15:00:00.000Z'); //campaign終了の日時(日本時間2023年1月1日0時)
        var currentDateTime = new Date();
        return endDateTime < currentDateTime;
    }, []);
    if (isPassedCampaignPeriod || !location.pathname.startsWith('/roaster'))
        return null;
    return (React.createElement(Dialog, { open: open, onClose: onClose },
        React.createElement(IconButton, { onClick: onClose, sx: { position: 'absolute', right: 8, top: 4 } },
            React.createElement(CloseDialogIcon, null)),
        React.createElement("img", { style: { width: '100%' }, src: campaignLocaleImage[i18n.language] })));
};
export default CampaignCheckDialog;
var templateObject_1;
